import { Image, Table, Popover, Popconfirm, Space } from "antd";
import { Link } from "react-router-dom";
import React, { Key } from "react";
import {
  LinkOutlined,
  PlusOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { persianDateFormat } from "./function.helper";
import { fallback } from "../constants/image.constant";
import { EditOutlined } from "@ant-design/icons";

export const columns = (lang: string) =>
  // setIsShowSkuModal: React.Dispatch<React.SetStateAction<boolean>>
  {
    return [
      {
        title: lang === "en-US" ? "Number" : "شماره",
        dataIndex: "Number",
        // key: "Name",
        sorter: false,
      },
      {
        title: (
          <Space>
            <span>sku</span>
            {/* <LinkOutlined /> */}
          </Space>
        ),
        dataIndex: "Sku",
        // key: "Sku",
        sorter: true,
      },
      {
        title: lang === "en-US" ? "Name" : "نام محصول",
        dataIndex: "Name",
        // key: "Name",
        sorter: true,
      },
      {
        title: lang === "en-US" ? "Image" : "تصویر",
        dataIndex: "imageUrl",
        // key: "imageUrl",
        render: (source: any) => (
          <Image
            width={40}
            src={source ? source : ""}
            placeholder={<Image preview={false} src={source} width={200} />}
            fallback={fallback}
          />
        ),
      },
      {
        title: lang === "en-US" ? "Manufacturer" : "نام سازنده ",
        dataIndex: "ManufacturerDisplayName",
        // key: "ManufacturerDisplayName",
        sorter: true,
      },
      {
        title: lang === "en-US" ? "ProductAdminUrl" : "لینک بک آفیس",
        dataIndex: "productAdminUrl",
        // key: "productAdminUrl",
        render: (source: any) => (
          <a href={source} target="_blank" rel="noopener noreferrer">
            <LinkOutlined />
          </a>
        ),
      },
      {
        title: lang === "en-US" ? "ProductUrl" : "لینک محصول",
        dataIndex: "productUrl",
        // key: "productUrl",
        render: (source: any) => (
          <a href={source} target="_blank" rel="noopener noreferrer">
            <LinkOutlined />
          </a>
        ),
      },
      {
        title: lang === "en-US" ? "productList" : "لیست محصول",
        dataIndex: "prdoctList",
        // key: "prdoctList",
        render: (id: any) => (
          <Link to={`/panel/product?Sku=${id}`}>
            <UnorderedListOutlined />
          </Link>
        ),
      },
      {
        title: lang === "en-US" ? "creationTime" : "تاریخ ایجاد",
        dataIndex: "creationTime",
        // key: "creationTime",
      },
      // creationTime
      {
        title: "عملیات",
        dataIndex: "actions",
        key: "actions",
        render: (source: any) => (
          <Popover content="ورود به انبار" trigger="hover">
            <Link
              to={`/panel/sku/towarehouse/${source.id}`}
              className="logo-normal"
              style={{
                backgroundColor: "#406882",
                border: "none",
                color: "white",
                padding: "4px 8px",
              }}
            >
              <PlusOutlined />
            </Link>
          </Popover>
        ),
      },
      Table.EXPAND_COLUMN,
    ];
  };

export const datahelper = (res: any, skipCount: number) => {
  const newData = res.map((item: any, index: number) => {
    return {
      ...item,
      key: skipCount + index + 1,
      Number: skipCount + index + 1,
      Sku: item.sku,
      Name: item.name,
      ManufacturerDisplayName: item.manufacturerDisplayName,
      // key: item.id,
      creationTime: persianDateFormat(item.creationTime),
      actions: item,
      // productAdminUrl: item.productAdminUrl,
      prdoctList: item.sku,
    };
  });

  return newData;
};
export const dataSelect = (res: any) => {
  const newData = res.map((item: any) => {
    return {
      ...item,
      Sku: item.sku,
      Name: item.name,
      ManufacturerDisplayName: item.manufacturerDisplayName,
      key: item.id,
      creationTime: persianDateFormat(item.creationTime),
      actions: item,
      count: 2,

      // productAdminUrl: item.productAdminUrl,
    };
  });
  return newData;
};

export const skuDatahelperSingle = (item: any) => {
  return {
    ...item,
    Sku: item.sku,
    Name: item.name,
    ManufacturerDisplayName: item.manufacturerDisplayName,
    key: item.id,
    creationTime: persianDateFormat(item.creationTime),
    actions: item,
  };
};

export const handleQueryString = (obj: any) => {
  let address: string = "";
  console.log("handleQueryString obj", obj);

  Object.entries(obj).map((item: any) => {
    if (item[1] || typeof item[1] === "boolean") {
      const result = address.concat(`${item[0]}=${item[1]}&`);
      address = result;
    }
    console.log("address", address);
  });
  return address;
};

export const handleToWarehouseParams = (
  skuId: number,
  type: number,
  quantity: string,
  warehouseId: string
) => {
  return {
    skuId,
    type,
    quantity,
    reserveId: null,
    warehouseId,
  };
};

export const selectedSkuCoulmns = (lang: string) => {
  return [
    {
      title: "Sku",
      dataIndex: "Sku",
      key: "Sku",
    },
    {
      title: lang === "en-US" ? "Name" : "نام محصول",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: lang === "en-US" ? "Image" : "تصویر",
      dataIndex: "imageUrl",
      key: "imageUrl",
      render: (source: any) => (
        <Image
          width={40}
          src={source ? source : ""}
          placeholder={<Image preview={false} src={source} width={200} />}
          fallback={fallback}
        />
      ),
    },
    {
      title: lang === "en-US" ? "Manufacturer" : "نام سازنده ",
      dataIndex: "ManufacturerDisplayName",
      key: "ManufacturerDisplayName",
    },

    {
      title: lang === "en-US" ? "creationTime" : "تاریخ ایجاد",
      dataIndex: "creationTime",
      key: "creationTime",
    },
    {
      // title: lang === "en-US" ? "count" : "تعداد",
      title:
        lang === "en-US" ? (
          <Space>
            <span>count</span>
            <EditOutlined />
          </Space>
        ) : (
          <Space>
            <span>تعداد</span>
            <EditOutlined />
          </Space>
        ),
      dataIndex: "count",
      key: "count",
      editable: true,
    },
    // {
    //   title: lang === "en-US" ? "name" : "نام",
    //   dataIndex: "name",
    //   key: "name",
    //   editable: true,
    // },
    // creationTime
  ];
};

export const aadtionBathCoulmns = (
  numbeerOfRow: number,
  handleDelete: any,
  lang: string
) => {
  return [
    {
      title: lang === "en-US" ? "number" : "شماره ردیف",
      dataIndex: "key",
    },
    {
      title: "skuId",
      dataIndex: "skuName",
    },
    {
      title: lang === "en-US" ? "quantity" : "تعداد",
      dataIndex: "quantity",
    },

    {
      title: lang === "en-US" ? "Delete" : "حذف",
      dataIndex: "operation",
      render: (_: any, record: { key: Key }) =>
        numbeerOfRow >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <a>Delete</a>
          </Popconfirm>
        ) : null,
    },
  ];
};

export const handleSelectRow = (
  rowNumber: any,
  selectedRowKeys: any,
  page: number
) => {
  console.log("🚀 ~ file: sku.helper.tsx ~ line 338 ~ page", page);
  console.log(
    "🚀 ~ file: sku.helper.tsx ~ line 338 ~ selectedRowKeys",
    selectedRowKeys
  );
  // console.log("🚀 ~ file: sku.helper.tsx ~ line 338 ~ rowKeys", rowKeys);

  // 0 -40
  // 40-80
  const test1 = rowNumber.filter(
    (item: number) => item > page * 40 && item <= page * 40 + 40
  );

  const test2 = selectedRowKeys.filter(
    (item: number) => item > page * 40 && item <= page * 40 + 40
  );

  const test3 = selectedRowKeys.filter(
    (item: number) => item <= page * 40 || item > page * 40 + 40
  );
  // console.log("test1 row", test1);
  // console.log("test2 state", test2);
  // console.log("test3", test3);

  // condition is not
  if (test1.length > test2.length) {
    const dataKyes = [...selectedRowKeys, ...test1];
    let uniques = Array.from(new Set(dataKyes));
    return uniques;
  } else {
    const dataKyes = [...test3, ...test1];
    let uniques = Array.from(new Set(dataKyes));
    return uniques;
  }
};

export const handleUniqueGetList = (list: any) => {
  const seen = new Set();
  const filteredArr = list.filter((el: any) => {
    const duplicate = seen.has(el.key);
    seen.add(el.key);
    return !duplicate;
  });
  return filteredArr;
};
